const products = [
    {
        modelNumber: '-NDJVeHLb7o48aLvfQ31',
        model: 'MX42',
        name: 'HDMI XT-HDMI-MX42-4K Status',
        version: '2.02',
        status: {
            power: true,
            ir: false,
            key: false,
            beep: false,
            lcd: false,
        },
        inputs: [
            {
                port: '01',
                name: 'HDMI1',
            },
            {
                port: '02',
                name: 'HDMI2',
            },
            {
                port: '03',
                name: 'HDMI3',
            },
            {
                port: '04',
                name: 'HDMI4',
            },
        ],
        outputs: [
            {
                input: '01',
                port: '01',
                name: 'HDMI 1',
                outputEnabled: true,
                hdmiCon: true,
                osp: 'SRC',
            },
            {
                input: '02',
                port: '02',
                name: 'HDMI 2',
                outputEnabled: true,
                hdmiCon: true,
                osp: 'SRC',
            },
        ],
    },
    {
        modelNumber: '-NDJVeHLb7o48aLvfQ32',
        model: 'MX44',
        name: 'HDMI XT-HDMI-MX44-4K Status',
        version: '2.02',
        status: {
            power: true,
            ir: false,
            key: false,
            beep: false,
            lcd: false,
        },
        inputs: [
            {
                port: '01',
                name: 'HDMI1',
            },
            {
                port: '02',
                name: 'HDMI2',
            },
            {
                port: '03',
                name: 'HDMI3',
            },
            {
                port: '04',
                name: 'HDMI4',
            },
        ],
        outputs: [
            {
                input: '01',
                port: '01',
                name: 'HDMI 1',
                outputEnabled: true,
                hdmiCon: true,
                osp: 'SRC',
            },
            {
                input: '02',
                port: '02',
                name: 'HDMI 2',
                outputEnabled: true,
                hdmiCon: true,
                osp: 'SRC',
            },
            {
                input: '03',
                port: '03',
                name: 'HDMI 3',
                outputEnabled: true,
                hdmiCon: true,
                osp: 'SRC',
            },
            {
                input: '04',
                port: '04',
                name: 'HDMI 4',
                outputEnabled: true,
                hdmiCon: true,
                osp: 'SRC',
            },
        ],
    },
];
export class Xantech {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.asyncHandlers = [
            {
                name: 'status',
                regExp: /STATUS/i,
                callback: (match) => {
                    this.socket.send(this.createStatusMessage(this.product));
                },
            },
            {
                name: 'power',
                regExp: /(PON|POFF)/i,
                callback: (match) => {
                    this.product.status.power = match[1] === 'PON';
                    this.socket.send(`${this.product.status.power ? 'PON' : 'POFF'}\r\n[SUCCESS]Set system power ${this.product.status.power ? 'ON, please wait a moment... Done' : 'OFF.'}`);
                },
            },
            {
                name: 'matrixRoute',
                regExp: /OUT(\d+)FR(.+)/i,
                callback: (match) => {
                    if (match[1] == '00') {
                        // All outputs were specified, so update routing for each output.
                        this.product.outputs.forEach(out => {
                            out.input = match[2];
                        });
                        this.socket.send(`[SUCCESS]Set all output connect from input ${match[2]}.`);
                    }
                    else {
                        const outputIndex = parseInt(match[1], 10) - 1;
                        this.product.outputs[outputIndex].input = match[2];
                        this.socket.send(`[SUCCESS]Set output ${match[1]} connect from input ${match[2]}.`);
                    }
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`[ERROR]Command not found.`);
                },
            },
        ];
        this.product = products[0];
    }
    onConfigure(config) {
        for (const product of products) {
            if (product.modelNumber === config.modelNumber) {
                this.product = product;
                return;
            }
        }
        this.log.error(`unexpected model number: ${config.modelNumber}`);
        this.product = products[0];
    }
    createStatusMessage(info) {
        let outString = 'STATUS\r\n\r\n' +
            '================================================================\r\n\r\n' +
            `               ${info.name}\r\n` +
            `               FW Version: ${info.version}\r\n` +
            `Power     IR    Key   Beep  LED\r\n` +
            `${info.status.power ? 'On' : 'Off'}       ` +
            `${info.status.ir ? 'On' : 'Off'}    ` +
            `${info.status.key ? 'On' : 'Off'}  ` +
            `${info.status.lcd ? 'On' : 'Off'}  \r\n` +
            'Input   Edid       HDMIcon\r\n';
        for (const value of info.inputs) {
            outString += `${value.port}      FORCE___00    On\r\n`;
        }
        outString += '\r\nOutput   FromIn  HDMIcon   OutputEn   OSP\r\n';
        for (const value of info.outputs) {
            outString += `${value.port}       ${value.input}           ${value.hdmiCon ? 'On' : 'Off'}      ${value.outputEnabled ? 'Yes' : 'No'}   SRC\r\n`;
        }
        outString += '================================================================\r\n';
        return outString;
    }
}
Xantech.emulatorType = 'socketEmulator';
Xantech.key = '-NE_kqNRqInHMgxB7lAx';
